<template>
    <MainPage />
</template>

<script>
import {
    mapActions
} from 'vuex'

import MainPage from '../components/MainPage.vue'

export default {
    data: () => ({}),
    components: {
        MainPage
    },
    methods: {
        ...mapActions(['getUserInfo','servicesList'])
    },
    async mounted() {
        //await this.getUserInfo(this)
        this.servicesList()
    }
}
</script>
